import React from "react"

const OrganisationSettingsContext = React.createContext({})

const { Provider, Consumer } = OrganisationSettingsContext

export { Provider, Consumer, OrganisationSettingsContext }
